import { Dispatch } from "@reduxjs/toolkit";
import { fetchAdminCustomerGroupChooserThunk } from "../slices/AdminCustomerGroupChooserSlice";
import { fetchCustomerChooserThunk } from "../slices/CustomerChooserSlice";

export function reloadAdminCustomerRelatedData(dispatch: Dispatch<any>) {
    dispatch(fetchCustomerChooserThunk());
    dispatch(fetchAdminCustomerGroupChooserThunk());
}